"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCategory = void 0;
var ProductCategory;
(function (ProductCategory) {
    ProductCategory["Battery"] = "battery";
    ProductCategory["BatterySolarBundle"] = "battery solar bundle";
    ProductCategory["BundleBuilder"] = "bundle builder";
    ProductCategory["CarbonNeutral"] = "carbon neutral";
    ProductCategory["Energy"] = "energy";
    ProductCategory["Mobile"] = "Mobile Plan";
    ProductCategory["Modem"] = "modem";
    ProductCategory["Nbn"] = "nbn";
    ProductCategory["Unknown"] = "unknown";
    ProductCategory["Voip"] = "Voip";
})(ProductCategory = exports.ProductCategory || (exports.ProductCategory = {}));
//# sourceMappingURL=ProductCategory.js.map